<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row justify="space-between" no-gutters align="center">
        <v-col cols="12" md="5">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1">Nossos distribuidores</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" v-for="item in dados" :key="item.dis_id">
          <v-card class="px-3 py-1 h-100 pt-4">
            <div class="imagem_area">
              <div class="imagem_area_bg">
              </div>
              <img v-if="item.dis_imagem != null" :src="item.dis_imagem" :alt="item.dis_nome">
              <img v-else src="../assets/img/logo-icon.png" alt="Logo StartIn">
            </div>
            <div class="text text-center mb-2 mt-3">
              {{item.dis_nome}}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      salvando: false,
      dialogOpen: false,
      search: '',
      modulos: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'dis_id'
        },
        { text: 'Nome', value: 'dis_nome' },
        { text: 'Imagem', value: 'dis_imagem' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      dados: [],
      instagram: {
        dis_nome: '',
        dis_imagem: ''
      }
    }
  },
  methods: {
    loadFunctions () {
      this.getDistributors()
      this.loading = false
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getDistributors () {
      this.loading = true
      await Api.get('distribuidores/distribuidores-vinculados')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                dis_id: item.dis_id,
                dis_nome: item.dis_nome,
                dis_imagem: item.dis_imagem,
                uuid_dis_id: item.uuid_dis_id
              })
            })
            this.dados = info
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os instagrams!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.imagem_area {
  align-items: center;
  display: flex;
  height: 250px;
  justify-content: center;
  position: relative;
  transition: all 0.3s;
  width: 100%;
  &_bg {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    filter: blur(5px);
    height: 250px;
    position: absolute;
    transition: all 0.3s;
    width: 100%;
  }
  img {
    margin: 0 auto;
    max-height: 250px;
    max-width: 100%;
    position: relative;
    transition: all 0.3s;
    @media screen and (max-width: 991px) {
      max-height: 150px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DistribuidoresLista.vue